import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const CodeBlock = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  animation: anime 3s ;

  @keyframes anime {
      0% {
        width: 100px;
        height: 100px;
      }
     
      100% {
        width: 100%;
        height: 100%;
`;

const CodeHeader = styled.div`
  background-color: #191A1F;
  padding: 0.75rem 1rem;

  & h1{
    font-size: 18px;
    text-align: center;
    margin: 0;
  }
`;

const Dot = styled.span`
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${(props) => props.color};
`;

const WhiteDot = styled.span`
  height: 4px;
  width: 4px;
  border-radius: 50%;
  display: inline-block;
  background-color: #fff;
`;

const CodeContent = styled.div`
  padding: 1rem 1.5rem;
  display: flex;
  font-size: 0.95rem;
  line-height: 1.6;
  overflow-x: auto;
  background: #1e1e1e;
`;

const LineNumbers = styled.pre`
  margin: 0;
  padding-right: 1rem;
  text-align: right;
  color: #888;
  user-select: none;
`;

const CodeLines = styled.pre`
  margin: 0;
  white-space: pre;
`;

const Key = styled.span`
  color: #ff4999;
`;

const Value = styled.span`
  color: #81ffd9;
`;


export default function JsonWindow() {
  const fullLines = [
    <> {'{'}</>,
    <></>,
    <>  <Key>"nome"</Key>: <Value>"Gabriel Barbosa"</Value>,</>,
    <>  <Key>"localização"</Key>: <Value>"Guarulhos, São Paulo - Brasil"</Value>,</>,
    <>  <Key>"classificação"</Key>: <Value>"Desenvolvedor"</Value>,</>,
    <>  <Key>"nível"</Key>: <Value>"Mid level_Pleno"</Value>,</>,
    <>  <Key>"formação"</Key>: {'{'} </>,
    <>    <Key>"técnico"</Key>: <Value>"Técnico em Informática - SENAC"</Value>,</>,
    <>    <Key>"graduação"</Key>: <Value>"Análise e Desenvolvimento de Sistemas - UNICSUL"</Value>,</>,
    <>    <Key>"pós_graduação"</Key>: <Value>"Offensive Cyber Security - FIAP"</Value> </>,
    <>  {'},'}</>,
    <>  <Key>"habilidades"</Key>: {'{'} </>,
    <>    <Key>"linguagens"</Key>: [<Value>"PHP"</Value>, <Value>"JavaScript"</Value>, <Value>"React.Js"</Value>, <Value>"JQuery"</Value>, <Value>"Python"</Value>, <Value>"HTML"</Value>, <Value>"CSS"</Value>, <Value>"SQL"</Value>],</>,
    <>    <Key>"ferramentas"</Key>: [</>,
    <>      <Value>"Ferramentas de monitoramento de sites e servidores"</Value>,</>,
    <>      <Value>"Integração de APIs"</Value>,</>,
    <>      <Value>"Monitoramento de desempenho"</Value>,</>,
    <>      <Value>"Análise de logs"</Value>,</>,
    <>      <Value>"Tecnologias de servidor"</Value>,</>,
    <>      <Value>"Scripts de automação"</Value>,</>,
    <>      <Value>"Bootstrap, Tailwind"</Value>,</>,
    <>      <Value>"Wordpress"</Value> </>,
    <>    ],</>,
    <>  {'},'}</>,
    <>  <Key>"experiência"</Key>: [</>,
    <>    <Value>"Integrações com APIs REST"</Value>,</>,
    <>    <Value>"Automação de processos"</Value>,</>,
    <>    <Value>"Integração/Entrega contínua (CI/CD)"</Value>,</>,
    <>    <Value>"Gerenciamento de versões com Git"</Value>,</>,
    <>    <Value>"Monitoramento de infraestrutura"</Value> </>,
    <>  ]</>,
    <> {'}'}</>,
  ];

  const [visibleLines, setVisibleLines] = useState([]);

  useEffect(() => {
  let current = 0;
  let intervalId;
  const timeoutId = setTimeout(() => {
    intervalId = setInterval(() => {
      setVisibleLines((prev) => [...prev, fullLines[current]]);
      current++;

      if (current >= fullLines.length) clearInterval(intervalId);
    }, 100); 
  }, 1500);

  return () => {
    clearTimeout(timeoutId);
    clearInterval(intervalId);
  };
}, []);

  return (
    <CodeBlock>
      <CodeHeader>
        <div className='row justify-content-center'>
          <div className="align-items-center col-2 d-flex gap-2">
            <Dot color="#ff5f56" />
            <Dot color="#ffbd2e" />
            <Dot color="#27c93f" />
          </div>
          <div className="col-8">
            <h1>Gabriel Barbosa Portifólio.json</h1>
          </div>
          <div className="align-items-center col-2 d-flex gap-2 justify-content-end">
            <WhiteDot />
            <WhiteDot />
            <WhiteDot />
          </div>
        </div>
      </CodeHeader>
      <CodeContent>
        <LineNumbers>
          {visibleLines.map((_, index) => `${index + 1}`.padStart(2, ' ') + '\n')}
        </LineNumbers>
        <CodeLines>
          {visibleLines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </CodeLines>
      </CodeContent>
    </CodeBlock>
  );
}
